export default function() {
  return {
    bundlings: [],
    bundling: {},
    lists: []
  }
}
